// @ts-nocheck
import { hubService, userService, } from '@/services';
import PostHubFormDto from '@/form/form-dto/hub-management/PostHubFormDto';
const action = {
    async postHub(_, payload) {
        try {
            const reqData = new PostHubFormDto(payload);
            // 수정과 다르게 등록에서는 useYn을 보내지 않는다
            delete reqData.useYn;
            // 모든 headYn은 고정값 N으로 보낸다
            // https://barogo.slack.com/archives/C04UP4VFCKA/p1694410473611189?thread_ts=1694164263.552949&cid=C04UP4VFCKA
            await hubService.postHub({
                headYn: 'N',
                ...reqData,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            console.log('[postHub] ', message, reason);
            return {
                isSuccess: false,
                message,
                reason,
            };
        }
    },
    async isUserIdExist(context, { userId }) {
        const response = await userService.isUserIdExist({
            userId,
        });
        return response.data;
    },
    async isHubRepresentativePhoneExist({ rootGetters }, { hubRepresentativePhone }) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const distributorId = rootGetters['hubSelector/getterSubscribeDistributorHubId'];
        const response = await hubService.isHubRepresentativePhoneExist({
            hubId: distributorId ?? hubId,
            hubRepresentativePhone,
        });
        return response.data;
    },
};
export default action;
